import { Injectable, ErrorHandler, Injector } from '@angular/core';
import { AppError } from '@interticket/core';
import { StoreService } from '@core/services/store/store.service';
import { GlobalErrorHandler as CommonGlobalErrorHandler } from 'common';

/**
 * {@link} https://medium.com/angular-in-depth/expecting-the-unexpected-best-practices-for-error-handling-in-angular-21c3662ef9e4
 */
@Injectable()
export class GlobalErrorHandler extends CommonGlobalErrorHandler implements ErrorHandler {

  constructor(
    protected injector: Injector
  ) {
    super(injector);
  }

  handleError(error: AppError): void {
    // Angular Lazy Routes & loading chunk failed
    // https://medium.com/@kamrankhatti/angular-lazy-routes-loading-chunk-failed-42b16c22a377
    if (/Loading chunk [\d]+ failed/.test(error?.message)) {
      const store = this.injector.get(StoreService);
      store.isLoadingChunkFailed = true;
      return;
    }

    super.handleError(error);
  }

}
